import React, { useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';
import styles from './Can.module.css';

const IconTextComponent = ({ text, icon }) => {
  const playerRef1 = useRef(null);

  const handleComplete = () => {
    setTimeout(() => {
      if (playerRef1?.current && typeof playerRef1.current.playFromBeginning === 'function') {
        playerRef1.current.playFromBeginning();
      }
    }, 2500);
  };

  useEffect(() => {
    if (icon && playerRef1?.current) {
      const timer = setTimeout(() => {
        if (playerRef1?.current && typeof playerRef1.current.playFromBeginning === 'function') {
          playerRef1.current.playFromBeginning();
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [icon]);

  return (
    <div className={styles.container}>
      {icon && (
        <div className={styles.icon}>
          <Player 
            icon={icon} 
            ref={playerRef1} 
            size="100%" 
            colorize="#724121"
            stroke="light"
            onComplete={handleComplete}
            onReady={() => {
              if (playerRef1?.current && typeof playerRef1.current.playFromBeginning === 'function') {
                playerRef1.current.playFromBeginning();
              }
            }}
          />
        </div>
      )}
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default IconTextComponent;